"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activities = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const SynView_1 = require("../SynView");
const UseCase_1 = require("./UseCase");
const UseCaseGraph_1 = require("./UseCaseGraph");
require("./activities.tmpl.less");
require("./UseCase.less");
let r_useCaseTemplate = require("./useCase.tmpl.htm");
let dispatcherMap = {};
let dispatcherContext = require.context("./Dispatcher/", false, /[a-zA-Z0-9_]+\.ts$/);
dispatcherContext.keys().forEach((fileName) => {
    let item = dispatcherContext(fileName).default;
    for (let i = 0; i < item.matches.length; ++i) {
        let match = item.matches[i].toLowerCase();
        if (typeof dispatcherMap[match] !== "undefined")
            // eslint-disable-next-line no-console
            console.error("Command \"" + match + "\" is already matched by a dispatcher.");
        else
            dispatcherMap[match] = item;
    }
});
class activities extends SynView_1.SynView {
    constructor() {
        super();
        this.m_breadCrumb = [];
    }
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-circle-o";
    }
    renderContents() {
        let that = this;
        that.m_$breadCrumbNavigation = that.m_$container.find("#activitiesBreadCrumbNavigation");
        that.m_$tileHolder = that.m_$container.find("#activitiesTileHolder");
        UseCaseGraph_1.UseCaseGraph.createAsync().then((graph) => {
            graph.debug();
            that.m_breadCrumb = [UseCase_1.UseCaseGraphNode.GetVirtualRoot()];
            that.m_graph = graph;
            that.renderCurrentView();
        });
    }
    forceRefresh(modifications) { }
    get currentNode() {
        return this.m_breadCrumb[this.m_breadCrumb.length - 1];
    }
    renderBreadCrumbNavigation() {
        let that = this;
        that.m_$breadCrumbNavigation.html("&nbsp;");
        for (let i = 0; i < this.m_breadCrumb.length; ++i) {
            let $span = $("<span></span>").addClass("breadCrumb").appendTo(that.m_$breadCrumbNavigation);
            let $link = $("<a></a>").attr("href", "javascript:void(0)").appendTo($span);
            if (i === 0)
                $link.append($("<i class='fa fa-circle-o'></i>"));
            else
                $link.text(this.m_breadCrumb[i].m_name);
            if (i === this.m_breadCrumb.length - 1)
                $link.attr("disabled", "disabled");
        }
    }
    renderCurrentView() {
        let that = this;
        this.renderBreadCrumbNavigation();
        if (this.currentNode.m_type === UseCase_1.UseCaseNodeType.UseCase)
            that.renderEmbeddedUseCase();
        else
            that.renderCurrentLevel();
        that.registerEvents();
    }
    renderEmbeddedUseCase() {
        this.m_$tileHolder.html("");
        this.appendUseCaseElement(this.currentNode, true);
    }
    renderCurrentLevel() {
        let that = this;
        that.m_$tileHolder.html("");
        let allRecursiveUseCases = that.m_graph.descendants({
            startNode: this.currentNode,
            nodeTypes: UseCase_1.UseCaseNodeType.UseCase,
            recursive: true,
            removeDuplicates: true
        });
        let groups = that.m_graph.descendants({
            startNode: this.currentNode,
            nodeTypes: UseCase_1.UseCaseNodeType.Group,
            recursive: false,
            removeDuplicates: true
        });
        if (groups.length === 0 || allRecursiveUseCases.length <= activities.RemoveGroupsThreshold) {
            allRecursiveUseCases.sort((a, b) => a.m_name.localeCompare(b.m_name));
            for (let useCase of allRecursiveUseCases)
                that.appendUseCaseElement(useCase, false);
        }
        else {
            let nodesForThisLayer = [];
            groups.sort((a, b) => a.m_name.localeCompare(b.m_name));
            for (let group of groups) {
                let nodesUnderThisGroup = that.m_graph.descendants({
                    startNode: group,
                    nodeTypes: UseCase_1.UseCaseNodeType.UseCase,
                    recursive: true,
                    removeDuplicates: true
                });
                if (nodesUnderThisGroup.length === 1)
                    nodesForThisLayer.push(nodesUnderThisGroup[0]);
                else
                    nodesForThisLayer.push(group);
            }
            let nodesDirectlyUnderCurrentLayer = that.m_graph.descendants({
                startNode: this.currentNode,
                nodeTypes: UseCase_1.UseCaseNodeType.UseCase,
                recursive: false,
                removeDuplicates: true
            });
            for (let n of nodesDirectlyUnderCurrentLayer)
                nodesForThisLayer.push(n);
            nodesForThisLayer.sort((a, b) => Math.sign(10 * (a.m_type - b.m_type) + a.m_name.localeCompare(b.m_name)));
            for (let node of nodesForThisLayer)
                that.appendUseCaseElement(node, false);
        }
    }
    appendUseCaseElement(element, embedded) {
        if (embedded)
            this.m_$tileHolder.append($("<div class='useCaseElement embedded'></div>"));
        else {
            let tmpl = kendo.template(r_useCaseTemplate);
            let $elem = $(tmpl({ useCase: element, synUtil: Utilities_1.synUtil }))
                .attr("data-internalid", UseCaseGraph_1.UseCaseGraph.getInternalId(element))
                .data("graphNode", (element.m_type !== UseCase_1.UseCaseNodeType.Group ? element : undefined))
                .appendTo(this.m_$tileHolder);
            if (element.m_cssColor)
                $elem.find(".tile").css("background-color", element.m_cssColor);
        }
    }
    executeUseCaseAsync($useCase) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let graphNode = $useCase.data("graphNode");
            let dataObj = graphNode.m_dataObject;
            if (dataObj.command) {
                let dispatcher = dispatcherMap[dataObj.command.name.toLowerCase()];
                if (dispatcher) {
                    if (dispatcher.isBreadcrumbElement) {
                        this.m_breadCrumb.push(graphNode);
                        this.renderCurrentView();
                        yield dispatcher.execute(dataObj.command.name, dataObj.command.commandOptions, this.m_$container.find("div.useCaseElement"));
                    }
                    else {
                        yield dispatcher.execute(dataObj.command.name, dataObj.command.commandOptions);
                    }
                }
                else
                    Utilities_1.synUtil.Notifications.error("command " + dataObj.command.name + " not mappable.");
            }
        });
    }
    getRecursiveLeftOffset($selector) {
        let leftOffset = 0;
        let $parent = $selector;
        while ($parent.length) {
            leftOffset += $parent.offset().left;
            if ($parent.is("html"))
                break;
            $parent = $parent.parent();
        }
        return leftOffset;
    }
    registerEvents() {
        let that = this;
        let $useCaseElements = that.m_$tileHolder.find(".useCaseElement");
        if (that.m_breadCrumb.length > 1) {
            that.m_$breadCrumbNavigation
                .find(".breadCrumb:not(:last) > a")
                .click((e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                that.m_breadCrumb = that.m_breadCrumb.slice(0, $(e.target).closest(".breadCrumb").index(".breadCrumb") + 1);
                that.renderCurrentView();
            }));
        }
        $useCaseElements.find(".openGroup").parent().click((e) => {
            let parentLeftOffset = that.getRecursiveLeftOffset($useCaseElements);
            let internalId = $(e.target).closest(".useCaseGroup").attr("data-internalid");
            that.m_breadCrumb.push(that.m_graph.byInternalId(internalId));
            that.renderCurrentView();
        });
        $useCaseElements.find(".executeUseCase").parent().click((e) => {
            that.executeUseCaseAsync($(e.target).closest(".useCase"));
        });
    }
}
exports.activities = activities;
activities.RemoveGroupsThreshold = 7;
